import Vue from 'vue';
import { init, configureScope } from '@sentry/browser';
import { Vue as VueIntegration, ExtraErrorData } from '@sentry/integrations';

import currentUser from '@rover/globals/currentUser';

const PROD_SENTRY_DSN = 'https://9c4df485116d4051adee5543193eeac3@sentry.io/24119';
const DEV_SENTRY_DSN = 'https://663da0655fda48dd9e79d5d4b0d9d6bd@sentry.io/23944';

const dsn = process.env.NODE_ENV === 'production' ? PROD_SENTRY_DSN : DEV_SENTRY_DSN;

init({
  dsn,
  integrations: [new VueIntegration({ Vue }), new ExtraErrorData()],
});

currentUser
  .waitForAuthenticatedUserLoaded()
  .then(user => {
    configureScope(scope => scope.setUser({ id: user.id }));
  })
  .catch(() => {
    // Fail silently because it just means the user isn't authenticated
  });



// WEBPACK FOOTER //
// ../utilities/initSentry.js